import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Order } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<Order.Basic>> =>
	Http.get(baseUrl, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<Order.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const retrieveStatuses = (): Promise<Entity[]> => Http.get(`${baseUrl}/order-statuses`)
export const retrieveOrderStatistic = (): Promise<Order.Statistic> =>
	Http.get(`${baseUrl}/order-statistics`)
